import axios from 'axios'
import { REACT_APP_API } from '../../config';

export const createYearlyPercentageRate = async () => {
  try {
    await axios.post(`${REACT_APP_API}/abms/percentageRates`);
  } catch (error) {
    throw new Error(error)
  }
}